import { render, staticRenderFns } from "./CompanyAnswer_v2.vue?vue&type=template&id=1a04b296&"
import script from "./CompanyAnswer_v2.vue?vue&type=script&lang=js&"
export * from "./CompanyAnswer_v2.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAnswer_v2.vue?vue&type=style&index=0&id=1a04b296&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports